export default __webpack_public_path__ + "static/media/CardTitleSearch.1506358e.svg";